<template>
  <v-dialog width="500px"
            :value="value"
            @input="closeModal"
            :persistent="!readonly"
            scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbGold" dark text flat>
        <div class="text-h6">
          {{
            (methodNewViewEdit === 'edit' && $t('general.editProductPurchase')) ||
            (methodNewViewEdit === 'new' && $t('general.newProductPurchase')) ||
            (methodNewViewEdit === 'view' && $t('general.viewProductPurchase'))
          }}
        </div>
        <v-spacer/>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validForm" ref="form" lazy-validation>
          <v-row>

            <v-col cols="12">
              <v-text-field :label="$t('general.status')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="selectedItem.status.value"
                            @keyup.enter="submit"
                            :readonly="readonly"
                            autofocus
                            v-if="selectedItem.status"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field :label="$t('general.shippingAddress')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="selectedItem.shippingAddress"
                            @keyup.enter="submit"
                            :readonly="readonly"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field :label="$t('general.payAmount')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="selectedItem.payAmount"
                            @keyup.enter="submit"
                            :readonly="readonly"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field :label="$t('general.phone')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="selectedItem.phoneNumber"
                            @keyup.enter="submit"
                            :readonly="readonly"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field :label="$t('general.paymentDate')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="selectedItem.date"
                            @keyup.enter="submit"
                            :readonly="readonly"
              />
            </v-col>
            <template v-if="productItems && readonly">
              <template v-for="(item, index) in productItems">
                <v-col cols="12" md="4" :key="index" class="new-view-edit-image">
                  <v-card>
                    <v-img
                      :src="item.image ? item.image :
                        'https://storage.googleapis.com/pepperco/medellinstyle/img/products-list/product.svg'"
                      style="border-radius: 5px; max-height: 134px"
                      alt="Product photo" class="white--text align-end"
                      gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                      <v-card-title v-text="`${item.name} x${item.numberProducts}`"></v-card-title>
                    </v-img>
                    <!-- <v-card-actions>
                      <v-spacer></v-spacer>

                    </v-card-actions> -->
                  </v-card>
                </v-col>
              </template>
            </template>

          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="closeModal">
          {{methodNewViewEdit === 'view' ? $t('general.close') : $t('general.cancel')}}
        </v-btn>

        <v-btn @click="submit"
               color="kbGold"
               dark
               :loading="loading"
               v-if="methodNewViewEdit !== 'view'">
          {{ $t('general.saveChanges') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
// import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  components: { },
  computed: {
    ...mapState({
      methodNewViewEdit: state => state.events.methodNewViewEditPurchaseProduct
    }),
    selectedItem: {
      get () {
        return this.$store.state.events.selectedPurchaseProductObj
      },
      set (value) {
        this.$store.commit('SET_SELECTED_PURCHASE_PRODUCT', value)
      }
    },
    readonly () {
      return this.methodNewViewEdit === 'view'
    },
    productItems () {
      if (!Array.isArray(this.selectedItem.cartItems) || this.selectedItem.cartItems.length === 0) return false

      return this.selectedItem.cartItems.map(el => {
        return {
          image: Array.isArray(el.images) && el.images.length > 0 && el.images[0],
          numberProducts: el.numberProducts,
          name: el.name,
          sku: el.sku
        }
      })
    }
  },
  data () {
    return {
      validForm: false,
      rules
    }
  },
  methods: {
    submit () {
      // if (this.method === 'new') {
      //   this.newItem()
      // } else {
      //   this.updateItem()
      // }
    },
    closeModal () {
      // this.$refs.form.reset()
      this.newEditProductObj = {}
      this.$emit('input', false)
    }
  },
  watch: {
  },
  props: ['value', 'loading']
}
</script>
<style scoped>
</style>
